import { useContext, useEffect } from "react";
import StoreManagement from "../../components/StoreManagement";
import { AppContext } from "../../contexts/AppContext";
import { StoreExample } from "../../commons/constants";

const StoreManagementPage: React.FC = () => {
  const { setCurrentStore } = useContext(AppContext);

  useEffect(() => {
    setCurrentStore(StoreExample);
  }, []);

  return <StoreManagement />;
};

export default StoreManagementPage;
